import { Theme } from '@mui/material/styles';
import { isNil } from 'lodash-es';

import { Job } from '~hooks/useJob/models';
import UserStore from '~store/UserStore';
import { isViewerAccountCustomer } from '~utils/user/user-utils';

export function shouldAllowUserToAddNewLoads(
  job: Job,
  userStore: UserStore,
  isReadOnlyJob: boolean = false,
) {
  const permissions = userStore.getPermissions();

  const jobHasNotBeenApproved = isNil(job.billingApprovedAt);

  const isCustomerViewer = isViewerAccountCustomer(userStore, job.order?.account);

  return (
    permissions.canCreateLoad &&
    jobHasNotBeenApproved &&
    !isCustomerViewer &&
    !isReadOnlyJob
  );
}

// Wide enough to read as a flag at table-row density without eating into the first column.
const FLAGGED_LOAD_ROW_ACCENT_WIDTH_PX = 3;

export function flaggedLoadRowSx(theme: Theme) {
  // The light wash already reads on its own; the accent only compensates for the dark
  // surface, where a wash alone does not separate the row from the page.
  const isDark = theme.palette.mode === 'dark';

  return {
    bgcolor: theme.semantic.rowFlaggedBg,
    ...(isDark && {
      boxShadow: `inset ${FLAGGED_LOAD_ROW_ACCENT_WIDTH_PX}px 0 0 ${theme.palette.error.main}`,
    }),
  };
}
